import { Button, Input, TextField } from '@mui/material';
import React, { useState } from 'react'
import { CsvToHtmlTable } from 'react-csv-to-table';
import ReactFileReader from 'react-file-reader';
import './Test.css'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import { URL } from '../../constants/constant';
var axios = require('axios')
const sampleData = `Table: Table_1\n\n,Age 54 Yrs. 2 Mn. 4 Day Sex F ,Patient Id 2203039 Srl No. 9 ,\n,,UHID No. ,\n\n\n\n\n\nTable: Table_2\n\nB. Date ,03/03/2022 ,\nName ,Mrs. PREETI ,\nRef. By ,HDFC LIFE ,\n\n\n\n\n\nTable: Table_3\n\nHAEMOGLOBIN (Hb) ,7.3 ,gm/dl ,11.5 16.5 ,\nTOTAL LEUCOCYTE COUNT (TLC) ,5.700 ,/cumm ,4000 11000 ,\nDIFFERENTIAL LEUCOCYTE COUNT (DLC) ,,,,\nNEUTROPHIL ,53 ,% ,40 75 ,\nLYMPHOCYTE ,26 ,% ,20 45 ,\nEOSINOPHIL ,04 ,% ,01 06 ,\nMONOCYTE ,17 ,% ,02 10 ,\nBASOPHIL ,00 ,% ,0 0 ,\nESR WINTROBE ,12 ,,0 20 ,\nRBC COUNT ,3.27 ,Millions/cmm ,3.8 4.8 ,\nPC.V/HAEMATOCRIT ,24.8 ,% ,35 45 ,\nMCV ,75.8 ,fl. ,80 100 ,\nMCH ,22.3 ,Picogram ,27.0 31.0 ,\nMCHC ,29.4 ,gm/dl ,33 37 ,\nPLATELET COUNT (PC) ,2.04 ,Lakh/cmm ,1.50 - 4.00 ,\nRDW ,14.2 ,FL ,39.0 46.0 ,\n\n\n\n\n\nTable: Table_4\n\nBILIRUBIN TOTAL ,0.86 ,mg/dl ,0-10 ,\nCONJUGATED (D. Bilirubin) ,0.23 ,mg/dl ,0.00 0.25 ,\nUNCONJUGATED (I.D Bilirubin) ,0 63 ,mg/dl ,0 00 - 0.70 ,\nTOTAL PROTEIN ,6.9 ,gm/dl ,6.6 8.3 ,\nALBUMIN ,34 ,gm/dl ,3.4-4.8 ,\nSGOT ,23.9 ,IU/L ,0-32 ,\nSGPT ,26.4 ,IU/L ,00 33.0 ,\nLFT INTERPRET ,,,,\n\n\n\n\n\nTable: Table_5\n\nB. Date ,03/03/2022 ,\nName ,Mrs. PREETI ,\nRef. By ,HDFC LIFE ,\n\n\n\n\n\nTable: Table_6\n\nAge ,54 Yrs. 2 Mn. 4 Day ,\nSex ,F ,\n\n\n\n\n\nTable: Table_7\n\n,Age ,54 Yrs. 2 Mn. 4 Day ,Patient Id 2203039 ,\n,Sex ,F ,Srl No. 9 ,\n,,,UHID No. ,\n\n\n\n\n\nTable: Table_8\n\nB. Date ,03/03/2022 ,\nName ,Mrs. PREETI ,\nRef. By ,HDFC LIFE ,\n\n\n\n\n\nTable: Table_9\n\n,LIPID PROFILE ,,,\nTRIGLYCERIDES ,95.3 ,mg/dL ,40.0 165.0 ,\nTOTAL CHOLESTEROL ,185.0 ,mg/dL ,123.0 199.0 ,\nHDL CHOLESTEROL ,48.6 ,mg/dL ,40.0 79.4 ,\nVLDL ,19.06 ,mg/dL ,4.7 - 22.1 ,\nLDL CHOLESTEROL ,117.34 ,mg/dL ,63.0 129.0 ,\nTOTAL CHOLESTEROL/HDL RATIO ,3.807 ,,0.0 - 4.97 ,\nLDL / HDL CHOLESTEROL RATIO ,2.414 ,,0.00 3.55 ,\n\n\n\n\n\nTable: Table_10\n\n,Age ,54 Yrs. ,2 Mn. 4 Day ,Patient Id ,2203039 ,\n,Sex ,F ,,Srl No. ,9 ,\n,,,,UHID No. ,,\n\n\n\n\n\nTable: Table_11\n\nB. Date ,03/03/2022 ,\nName ,Mrs. PREETI ,\nRef. By ,HDFC LIFE ,\n\n\n\n\n\nTable: Table_12\n\nGAMMA GLUTAMYL TRANSPEPTIDASE ,36.3 ,U/L ,6.0 55.0 ,\nBLOOD SUGAR FASTING ,88.3 ,mg/dl ,60 110 ,\nHbA1c (GLYCOSYLATED HEMOGLOBIN) ,4.6 ,% ,,\nINTERPRETATION: ,,,,\n\n\n\n\n\nTable: Table_13\n\nB. Date ,03/03/2022 ,\nName ,Mrs. PREETI ,\nRef. By ,HDFC LIFE ,\n\n\n\n\n\nTable: Table_14\n\nHbA1c (%) ,Mean plasma glucose (mg/dl) ,\n6 ,- 126 ,\n7 ,- 154 ,\n8 ,- 183 ,\n9 ,- 212 ,\n10 ,- 240 ,\n11 ,- 269 ,\n12 ,- 298 ,\n\n\n\n\n\nTable: Table_15\n\n,Age 54 Yrs. 2 Mn. 4 Day ,Patient Id 2203039 ,\n,Sex F ,Srl No. 9 ,\n,,UHID No. ,\n\n\n\n\n\nTable: Table_16\n\nB. Date ,03/03/2022 ,\nName ,Mrs. PREETI ,\nRef. By ,HDFC LIFE ,\n\n\n\n\n\nTable: Table_17\n\nTest Name ,Value ,Unit ,Normal Value ,\nTRANSPARENCY ,CLEAR ,,,\nSPECIFIC GRAVITY ,1.025 ,,,\nPH ,6.5 ,,,\nURINE DIPSTICK ,,,,\nCHEMICAL EXAMINATION ,,,,\nALBUMIN ,NIL ,,,\nREDUCING SUGAR ,NIL ,,,\nMICROSCOPIC EXAMINATION ,,,,\nPUS CELLS ,2-4 ,/HPF ,,\nRBC'S ,NIL ,/HPF ,,\nCASTS ,NIL ,,,\nCRYSTALS ,NIL ,,,\nEPITHELIAL CELLS ,2-4 ,/HPF ,,\nBACTERIA ,NIL ,,,\nOTHERS ,NIL ,,,\n\n\n\n\n\n`;

const Test = () => {
    const [csvData, setCsvData] = useState([])
    const [caseId, setCaseId] = useState('');
    const [loading, setLoading] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    const handleDialogOpen  = () => {
        setIsOpen(true);
    }

    const handleDialogClose  = () => {
        setIsOpen(false);
    }

    const handleConfirm  = () => {
        console.log("new accepted")
        setIsOpen(false);
    }

    const handleFiles = files => {
        var reader = new FileReader();
        reader.onload =  (e) => {
          setCsvData(reader.result)
        }
        reader.readAsText(files[0]);
        console.log("testing")
      }

    const handleSubmit = () => {
        setLoading(true)
        var config = {
            method: 'post',
            url: URL.demystify_url + 'getLines?caseID=' + caseId.toString(),
            headers: {
              'accept': 'application/json'
            }
          };
          axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
            setCsvData(response.data)
            setLoading(false)
          })
          .catch(function (error) {
            console.log(error);
            setLoading(false)
            alert(error)
          });
    }
  return (
    <div style={{ marginTop: 100, textAlign: 'center' }}>
      <div style={{ margin: '0 auto', display: 'inline-block' }}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
            <span style={{ marginRight: '10px' }}> CaseId : </span>
            <TextField id="outlined-basic" label="caseId" variant="outlined" size='small' value={caseId} onChange={(event) => {setCaseId(event.target.value)}}/> 
        </div>
        <Button variant = 'contained' style={{ marginBottom: '10px', marginLeft: '25px' }} onClick={handleSubmit}>Submit</Button>
      </div>
      <div style={{ margin: '10%' }}>
        {loading ? <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop> : 
            <>
              {csvData.map((item) => (
                <div>
                  <div className='row'> 
                  <span> Page {item.page_num} : </span> 
                  <span> {item.row} </span>
                  </div>
                </div>
            ))}
            </>}
      </div>
      
    </div>
  )
}

export default Test